import styled from 'styled-components';

import { ButtonStyled } from '../../components/Button/Button.styled';
import Heading from '../../components/Heading/Heading.styled';
import Container from '../../components/Layout/Container.styled';
import { ElementWrapperStyled } from '../../components/Tooltip/Tooltip.styled';

export const SupHeadingStyled = styled(Heading)`
  padding-bottom: 15px;
  margin-bottom: 30px;

  ${({ theme }) => `
    border-bottom: 1px solid ${theme.borderColour};    
  `}
`;

export const MainTitleStyled = styled(Heading)`
  & + ${Heading} {
    margin-top: 10px;
  }
`;

export const SectionTitleStyled = styled(Heading)`
  margin-bottom: 15px;
  text-transform: capitalize;
`;

export const HomeWrapperStyled = styled(Container)`
  text-align: justify;
  line-height: 24px;
`;

export const MainTitleWrapperStyled = styled.div`
  margin-bottom: 35px;
`;

export const SectionWrapperStyled = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  &:nth-child(2) {
    flex: 15%;
  }

  ${({ theme }) => `
    & + & {
      padding-left: 30px;
      margin-left: 30px;

      border-left: 1px solid ${theme.borderColour};

      ${theme.devices.touch} {
        padding: 20px 0 0;
        margin: 20px 0 0;
        border-left: none;
        border-top: 1px solid ${theme.borderColour};
      }
    }
  `}
`;

export const ContentWrapperStyled = styled.div`
  display: flex;

  ${({ theme }) => `
    ${theme.devices.touch} {
      flex-direction: column;
    }
  `}
`;

export const SingleButtonWrapperStyled = styled.div`
  margin-top: 30px;
  text-align: center;

  ${ButtonStyled} {
    max-width: 285px;
    width: 100%;

    ${({ theme }) => `
      ${theme.devices.mobile} {
        max-width: 100%;
      }
    `}
  }
`;

export const TitleWithTooltipWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  margin-bottom: 15px;

  ${SectionTitleStyled} {
    margin-bottom: 0;
  }

  ${ElementWrapperStyled} {
    ${({ theme }) => `
      color: ${theme.primaryColour};
    `}
  }
`;

export const ImppactSectionWrapperStyled = styled(SectionWrapperStyled)`
  ${({ theme }) => `
    ${theme.devices.touch} {
      order: 1;
      padding: 20px 0 0;
      margin: 20px 0 0;
      border-top: 1px solid ${theme.borderColour};
    }
  `}
`;
